import inView from "in-view";

export default function () {
  document
    .querySelectorAll(
      ".home-slider .content, .from-left, .from-right, .from-bottom, .from-top",
    )
    .forEach((el) => el.classList.add("invisible"));

  inView(".home-slider .content").on("enter", (el) => {
    el.classList.remove("invisible");
    el.classList.add("is-animate");
  });

  inView(".from-left").on("enter", (el) => {
    el.classList.remove("invisible");
    el.classList.add("fade-in-left");
  });

  inView(".from-right").on("enter", (el) => {
    el.classList.remove("invisible");
    el.classList.add("fade-in-right");
  });

  inView(".from-bottom").on("enter", (el) => {
    el.classList.remove("invisible");
    el.classList.add("fade-in-bottom");
  });

  inView(".from-top").on("enter", (el) => {
    el.classList.remove("invisible");
    el.classList.add("fade-in-top");
  });

  window.addEventListener("scroll", () => {
    if (document.body.classList.contains("single-recettes")) {
      const stepsContainer = document.querySelector(".steps-container");
      if (stepsContainer) {
        const topblock =
          stepsContainer.getBoundingClientRect().top + window.scrollY - 600;
        const scroll = window.scrollY;
        const maxscroll = stepsContainer.offsetHeight;

        if (scroll >= topblock && scroll <= maxscroll) {
          inView.offset(200);
        }
      }
    }
  });

  inView(".step-single")
    .on("enter", (el) => el.classList.add("active"))
    .on("exit", (el) => el.classList.remove("active"));
}
